import { ApprovalableTypeEnum } from 'api-hooks/common';
import { OtherExpensesModel } from 'api-hooks/other-expense';
import { OtherIncomeModel } from 'api-hooks/other-income';

export default function defaultValue(
  data: OtherExpensesModel | OtherIncomeModel,
  approvalableType: string,
) {
  const defaultValues: any = {
    id: data.id,
    accountType: data.accountType,
    amount: data.amount,
    description: data.description,
    accountable: data.accountable?.id,
    transactionAt: data.transactionAt,
    status: data.status,
  };

  if (approvalableType === ApprovalableTypeEnum.OtherIncome) {
    const temp = data as OtherIncomeModel;
    return {
      ...defaultValues,
      acknowledgedAt: temp.acknowledgedAt,
    };
  }

  return defaultValues;
}
